<mat-card-content>
  <ng-container *ngIf="c2c">
    <table class="mat-table data-table" [style]="{'margin-top': '25px'}">
      <ng-container *ngIf="privateClaim()">
        <tr>
          <th>Mitarbeiter-Zugang für</th>
          <td>{{c2c.external_customer_id}}</td>
        </tr>
      </ng-container>
      <ng-container *ngIf="c2c.id">
        <tr>
          <th>Zugangsnummer</th>
          <td>{{c2c.external_claim_id}}</td>
        </tr>
        <tr>
          <th>Einladungs-Code</th>
          <td>{{c2c.crc32}}</td>
        </tr>
        <tr>
          <th>Aktivierungs-Schlüssel</th>
          <td>{{c2c.md5}}</td>
        </tr>
      </ng-container>
    </table>

  </ng-container>
  <ng-container *ngIf="c2cFormGroup && c2c">
    <form class="user-form" [formGroup]="c2cFormGroup">
      <mat-grid-list cols="8" rowHeight="100px">

        <mat-grid-tile colspan="2">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Zugangsnummer</mat-label>
            <input [disabled]="true" type="text" [value]="c2c.external_claim_id" matInput formControlName="external_claim_id">
          </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="3">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Typ</mat-label>
            <mat-select [(value)]="c2c.scope" formControlName="scope">
              <ng-container *ngIf="customerData.all_scopes; else noScopes">
                <mat-option *ngFor="let scope of customerData.all_scopes" value="{{scope.name}}">{{scope.desc}}</mat-option>
              </ng-container>
              <ng-template #noScopes>
                <mat-option value="sta_epaper">E-Paper-Abonnement</mat-option>
                <mat-option value="sta_download">Digitaler Download</mat-option>
              </ng-template>
            </mat-select>
          </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="3">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Zugang</mat-label>
            <mat-select [disabled]="false" [(value)]="c2c.claim_name" formControlName="claim_name">
              <ng-container *ngIf="customerData.all_claims; else noClaims">
                <mat-option *ngFor="let c of customerData.all_claims" value="{{c.name}}">{{c.desc}}</mat-option>
              </ng-container>
              <ng-template #noClaims>
                <mat-option value="sta_epaper_sta">Staatsanzeiger</mat-option>
                <mat-option value="sta_epaper_stalbw">Staatsanzeiger + Landesausschreibungsblatt</mat-option>
              </ng-template>
            </mat-select>
          </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="1">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Maximale Anzahl der Zugänge</mat-label>
            <input type="number" value="{{c2c.max_user_count}}" matInput formControlName="max_user_count">
          </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="1">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Max Anzahl von Sitzungen pro Konto</mat-label>
            <input type="number" value="{{c2c.max_sessions_per_user}}" matInput formControlName="max_sessions_per_user">
          </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="1">
          <mat-slide-toggle
            formControlName="claim_value"
            [checked]="c2c.claim_value === 'true'">
            Aktiv
          </mat-slide-toggle>
        </mat-grid-tile>

        <mat-grid-tile colspan="2">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Gültig von</mat-label>
            <input matInput [matDatepicker]="fromPicker" formControlName="start">
            <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
            <mat-datepicker #fromPicker></mat-datepicker>
          </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="2">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Gültig bis</mat-label>
            <input matInput [matDatepicker]="toPicker" formControlName="expires">
            <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
            <mat-datepicker #toPicker></mat-datepicker>
          </mat-form-field>
        </mat-grid-tile>

      </mat-grid-list>

      <div mat-subheader>Abonnenten  ({{pager.length ? pager.length : 0}})</div>

      <ng-container *ngIf="subscribersDataSource && (c2c.claims2user && c2c.claims2user.length); else noSubs">
        <table mat-table [dataSource]="subscribersDataSource" class="customer-table">
          <ng-container matColumnDef="icon">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let c2u">
              <mat-icon mat-list-icon>face</mat-icon>
            </td>
          </ng-container>
          <!-- Position Column -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef> Name</th>
            <td mat-cell *matCellDef="let c2u"> {{c2u.user ? c2u.user.name : 'Undefiniert'}} </td>
          </ng-container>

          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef> Email</th>
            <td mat-cell *matCellDef="let c2u"> {{c2u.user ? c2u.user.email : 'Undefiniert'}} </td>
          </ng-container>

          <ng-container matColumnDef="delete" class="edit">
            <th mat-header-cell *matHeaderCellDef> Löschen</th>
            <td mat-cell *matCellDef="let c2u" (click)="deleteClaim2User(c2u)">
              <mat-icon matTooltip="Zugang löschen" matTooltipPosition="above">delete</mat-icon>
            </td>
          </ng-container>

          <ng-container matColumnDef="edit" class="edit">
            <th mat-header-cell *matHeaderCellDef> Bearbeiten</th>
            <td mat-cell *matCellDef="let c2u">
              <mat-icon matTooltip="Nutzer bearbeiten" matTooltipPosition="above" *ngIf="c2u.user" (click)="open(c2u.user)" mat-list-icon>edit</mat-icon>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </ng-container>

      <!--  end Table-->

      <mat-paginator *ngIf="pager.length && pager.length > 5"
                     [length]="pager.length"
                     [pageSize]="pager.pageSize"
                     [pageIndex]="pager.pageIndex"
                     [pageSizeOptions]="[5,10,25]"
                     (page)="switchPage($event)">
      </mat-paginator>

      <ng-template #noSubs>
        <p *ngIf="c2c.id"><strong>Der Zugang hat keine Abonnenten!</strong></p>
      </ng-template>
      <ng-container *ngIf="c2c.id">
        <p>
          <button mat-raised-button (click)="invitationModal()">Nutzer einladen
            <mat-icon>mail</mat-icon>
          </button>
        </p>
      </ng-container>

      <div class="actions">
        <button (click)="saveClaim2Customer()" mat-raised-button color="accent">Speichern
          <mat-icon>save</mat-icon>
        </button>

        <button *ngIf="c2c.id" (click)="deleteClaim2Customer(c2c)" mat-raised-button color="danger">Zugang Löschen
          <mat-icon>delete</mat-icon>
        </button>
      </div>

    </form>
  </ng-container>

</mat-card-content>



